import React from 'react';
import PropTypes from 'prop-types';

export default function ATT({ twilioNumber }) {
  return (
    <div>
      <p>Login to your Ring Central account in the browser</p>
      <h6>After hours</h6>
      <ul>
        <li>The company line is directly forwarded to the {twilioNumber}</li>
      </ul>
      <h6>During business hours</h6>
      <ul>
        <li>
          Any extension that receives inquiries or booking-requests is forwarded to {twilioNumber}
        </li>
      </ul>

      <p>
        If you do want to use queues (not recommended):
      </p>
      <ul>
        <li>
          Select the particular queue and click on &quot;Call Handling&quot;
        </li>
        <li>Under &quot;Call Queue Hours&quot;, choose &quot;In fixed order&quot;</li>
        <li>
          Choose your desired settings under &quot;Audio while connecting&quot;
          and &quot;Hold music&quot;
        </li>
        <li>
          Under &quot;Member availability and hold times&quot;,
          you can set the max time to wait on a particular extension,
          before moving to the next one (typically 30-60 seconds)
        </li>
        <li>
          At the end of the queue, the call can be forwarded to your {twilioNumber}
        </li>
      </ul>
    </div>
  );
}

ATT.defaultProps = {
  twilioNumber: '',
};

ATT.propTypes = {
  twilioNumber: PropTypes.string,
};
